import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';


import { getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Select from '../../component/Select';
import Checkbox from '../../component/Checkbox';

export default function CompanyNotice({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [memberinfos, setmemberinfos] = useState(''); 
    const [lists, setlists] = useState([]); 
    const [writeflag, setwriteflag] = useState(false); 
    const [errmsg, seterrmsg] = useState(['', '']);   

    const [title, settitle] = useState('');   
    const [desc, setdesc] = useState('');   
    const [selnoticeidx, setselnoticeidx] = useState(location?.state?.vidx ? location?.state?.vidx : '');   
    const [uidx, setuidx] = useState('');   
    const [checkvalues, setcheckvalues] = useState([]);   



    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);


    useEffect(() => {
        seterrmsg(errmsg?.map(( xe, ie ) => ''));
        
    }, [title, desc]);

    useEffect(() => {
        listopen();
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/compony/news', sender).then(({ data }) => {
            if(data){
                setlists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }

    const newsUpdate = (uidx=null, removed=false) => {
        if(removed === false){
            if(title === ''){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 0 ? '제목을 입력해주세요.' : xe));
                return;
            }
            if(desc === ''){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '내용을 입력해주세요.' : xe));
                return;
            }
        }

        dispatch(loadingflas({ loading: true }));
        let sender = {
            idx: uidx,
            title: title,
            desc: desc,
            notices: checkvalues?.length > 0 ? 1 : 0,
            remove: removed
        }
        APIS.postData('/v1/master/newsUpdate', sender).then(({ data }) => {
            if(data){
                setwriteflag(false);
                listopen();
                setuidx('');
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });     
    }

    return(
        <>
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={1} />
                </div>
                <div 
                    className='padding32'
                >
                    <div className='pagetitle fontsize20 bolds'>사무소관리</div>
                    <div className='pagetabs margint20'>
                        <button className='active' onClick={() => { navigate('/CompanyNotice') }}>사내공지</button>
                        <button onClick={() => { navigate('/CompanyInfo') }}>사무소정보</button>
                        {/* <button onClick={() => { navigate('/CompanyCalc') }}>정산</button> */}
                    </div>
                    
                    {writeflag === true ? 
                    <div className='margint20'>
                        <div className='backbuttonarea'>
                            <div>
                                <button onClick={() => { setwriteflag(false); }}>
                                    <img src={`./images/icons/back.svg`} /> 
                                </button>
                                <span className='fontsize16 bolds'>등록하기</span>
                            </div>
                            <button onClick={() => { setwriteflag(false); }}>
                                사내공지
                            </button>
                        </div>
                        <div >
                            <Checkbox
                                linetype={'checkimg'}
                                values={checkvalues}
                                setvalues={(e) => {
                                    console.log(e);
                                    setcheckvalues(e);
                                }}
                                namevalue={[
                                    {names: '필독', values: 1},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </div>
                        <div className='margint8'>
                            <Input 
                                className={`inputs`}
                                setValue={settitle}
                                value={title}
                                name="mb_phone"
                                placeholder={'제목을 입력하세요.'}
                                error={errmsg[0]}
                            /> 
                        </div>
                        <div className='margint8'>
                            <textarea
                                onChange={(e) => {
                                    setdesc(e.target.value);
                                }}
                                placeholder='내용을 입력해 주세요.'
                                style={{
                                    width: '100%', height: 400, padding: 12,
                                    borderRadius: 4, border: '1px solid #DDD'
                                }}
                            >{desc}</textarea>
                        </div>
                        {errmsg[1] !== '' &&
                        <div>
                            <p className="input_error"><span></span>{errmsg[1]}</p>
                        </div>
                        }
                        <div 
                            className='margint20'
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                            }}
                        >
                            <div style={{ width: '50%' }}>
                                <Button
                                    buttonTxt={'취소'}
                                    disabled={true} 
                                    onPress={() => { 
                                        setwriteflag(false);
                                    }}
                                />                                       
                            </div>
                            <div style={{ width: '50%'}}>
                                <Button
                                    buttonTxt={'등록'}
                                    styles={{ 
                                    }} 
                                    onPress={() => { 
                                        if(uidx !== ''){
                                            newsUpdate(uidx, false);
                                        } else {
                                            newsUpdate();
                                        }
                                    }}
                                />     
                            </div>                            
                        </div>                            
                    </div>                    
                    :
                    <>
                    <div 
                        className='margint20'
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'flex-end'
                        }}
                    >
                        <Button
                            buttonTxt={'공지등록'}
                            className={'linenormalbutton'}
                            styles={{
                                width: 120, height: 40, fontSize: 14
                            }}
                            onPress={() => {
                                setwriteflag(true);
                                setuidx('');
                                settitle('');
                                setdesc('');                                
                            }}                             
                        />
                    </div>                    
                    <div className='faqlistArea margint20'>
                        {lists?.length > 0 && lists?.map((x, i) => {
                            if(i > 20){
                                return;
                            }
                            return (
                                <div 
                                    className={`faqlistView `}
                                    key={i}
                                    style={{
                                        cursor: 'pointer', 
                                    }}
                                    onClick={() => {
                                        //navigate('/UseguideDetail', {state: { vidx: x?.idx }});
                                        setselnoticeidx(selnoticeidx*1 === x?.idx ? '' : x?.idx);
                                    }}
                                >
                                    <div>
                                        <div 
                                            className='textcut_online'
                                            style={{ 
                                                display: 'inline-block', width: 'calc(100% - 140px)', textAlign: 'left',
                                                fontWeight: 700, fontSize: 16
                                            }}
                                        >
                                            {x?.notices*1 === 1 ? '[필독] ' : ''}{x?.title}
                                        </div>  
                                        <div>
                                            {moment(x?.create_dt).format('YYYY.MM.DD HH:MM')}
                                        </div>  
                                    </div>
                                    {selnoticeidx*1 === x?.idx &&
                                        <>
                                        <div style={{ whiteSpace: 'pre-wrap' }}>
                                            {x?.desc}
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: 20, gap: 20
                                            }}
                                        >
                                            <button
                                                onClick={() => {
                                                    newsUpdate(x?.idx, true);
                                                }}
                                            >삭제</button>
                                            <button
                                                onClick={() => {
                                                    //newsUpdate(x?.idx, true);
                                                    setwriteflag(true);
                                                    setuidx(x?.idx);
                                                    settitle(x?.title);
                                                    setdesc(x?.desc);
                                                    
                                                    setcheckvalues(x?.notices*1 === 1 ? [{names: '필독', values: 1}] : []);
                                                }}
                                            >수정</button>                                            
                                        </div>
                                        </>
                                    }
                                </div>
                            );
                        })}
                        {lists?.length === 0 &&
                            <div className='nolistArea'>
                                사무소 공지가 없습니다.
                            </div>
                        }
                    </div>
                    </>
                    }


                </div>
            </div>
        </Layout>

        </>
    )
}

